import { AxiosRequestConfig } from 'axios';
import { IData } from 'types';
import { axiosInstanceWithToken } from 'utils/axios';

export const fetchViewable = async (data: IData) =>
  axiosInstanceWithToken().post('design-automation/get-viewable', data);

export const runItem = async (data: IData) =>
  axiosInstanceWithToken().post('design-automation/work-items/run-item', data);

export const fetchInitials = async (data: IData) =>
  axiosInstanceWithToken().post('design-automation/work-items/getinitials', data);

export const saveOrder = async (data: IData) => axiosInstanceWithToken().post('design-automation/save-order', data);

export const deleteObject = async (data: IData) =>
  axiosInstanceWithToken().post('design-automation/delete-object', data);

export const uploadDesignFile = async (data: IData | FormData, config: AxiosRequestConfig) =>
  axiosInstanceWithToken().post('design-automation/upload-file', data, config);

export const fetchBuckets = async () => axiosInstanceWithToken().get('design-automation/get-buckets');

export const fetchBucketFile = async (id: string | number, params: IData) =>
  axiosInstanceWithToken().get(`design-automation/get-file/${id}/${params}/details`);
